<template>
    <div class="headers">
         <div class="home-logo">
          <!-- <img class="logo" src="" alt=""> -->
          <div class="logo-cont">
            <!-- <i class="el-icon-menu"></i> -->
            <img style="width: 80px;height: 80px;margin: 0px 5px;" src="https://www.hfcer.cn/static/hhz-th-upload/xcximg/avatar.png" alt="" />
            <span>红河林碳</span>
          </div>
        </div>
        <el-header class="home-header">
          <div class="header-left">
            <span class="bborder">红河林碳管理平台</span>
          </div>
          <div class="header-right">
            <!-- <div><i class="el-icon-close-notification"></i></div>
            <div><i class="el-icon-more"></i></div>
            <div><i class="el-icon-download"></i></div> -->
            <el-dropdown @command="handleCommand">
              <div class="userInfo">
                <el-avatar
                  :size="30"
                  src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                ></el-avatar>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
    </div>
</template>
<script>
import {logout} from "@/api/api.js"
export default {
    data(){
        return{

        }
    },
    methods:{
        // 退出登录
        handleCommand(command) {
          if (command == "logOut") {
            logout().then(res=>{
              if(res.data&&res.data.code==='200'){
                localStorage.clear()
                this.$router.push("/");
                this.$message.success("退出成功");
              }
            })
          }
        },
    }
}
</script>
<style scoped>
.headers{
    display: flex;
    align-items: center;
}
::v-deep .el-header{
    padding: 0;
}
.home-logo {
  width: 17.66667%;
  /* width: 300px; */
  box-sizing: border-box;
  height: 90px;
  line-height: 90px;
  /* background: #ccc; */
  border-bottom: 2px solid rgb(226, 226, 226);
}
.logo-cont {
  display: flex;
  align-items: center;
  justify-content: left;
  color: #333;
}
.logo-cont img {
  width: 100px;
  /* width: 40px; */
  height: 40px;
  display: block;
}
.logo-cont span {
  font-size: 18px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
}
.logo-cont i {
  font-size: 30px;
  margin-right: 5px;
  color: #ffa500;
}
.home-header {
    padding-right: 20px;
    width: calc(100% - 300px);
    border-bottom: 2px solid rgb(226, 226, 226);
    flex: 1;
    display: flex;
    align-content: center;
    justify-content: space-between;
}
.header-left {
  display: flex;
}
.header-left > span {
  position: relative;
  line-height: 60px;
  font-size: 16px;
  color: #606266;
  white-space:nowrap;
  /* overflow: hidden; */
  text-overflow: ellipsis;
}
.header-left > .bborder::before {
  content: "";
  position: absolute;
  height: 2px;
  background: #00BFBF;
  left: 0;
  right: 0;
  bottom: -2px;
}
.header-right {
  display: flex;
  align-items: center;
}
.header-right div {
  margin-left: 10px;
  width: 30px;
  font-size: 20px;
}
.header-right .userInfo {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  overflow: hidden;
  /* background: #FFA500; */
  color: #fff;
  font-size: 12px;
}
</style>